import type { Dictionary } from '../LocalizationProvider.types';

export const getDayNames = (dict: Dictionary) => [
  dict['day-sunday'],
  dict['day-monday'],
  dict['day-tuesday'],
  dict['day-wednesday'],
  dict['day-thursday'],
  dict['day-friday'],
  dict['day-saturday'],
  dict['day-sunday'],
];
